import tippy from 'tippy.js';

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', () => {
    tippy('[data-tippy-content]');
});
